import { TaskStatusEnumEnum } from 'shared/domains/apollo/generated/types';
export function filterTasks(tasks) {
    const filteredTasksEmpty = {
        uncompletedTasks: [],
        completedTasks: [],
    };
    return tasks.reduce((prev, current) => {
        const tmp = Object.assign({}, prev);
        if (current.isCompleted || current.status === TaskStatusEnumEnum.Completed) {
            tmp.completedTasks.push(current);
            return tmp;
        }
        tmp.uncompletedTasks.push(current);
        return tmp;
    }, filteredTasksEmpty);
}
